// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../public/Images/Misc/SeriesPackageInstructions.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../public/Images/Misc/TopCornerButton.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../public/Images/Misc/TopCornerButton_Hover.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../public/Images/Misc/TopCornerBar.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#topBarRoot {
  display: flex;

  position: absolute;

  width: 100%;
  height: 100%;

  align-items: center;
  justify-content: center;

  background-color: transparent;

  z-index: 100;

  pointer-events: none;
}

#topBarRoot_Intro {
  display: flex;

  position: absolute;

  width: 100%;
  height: 100%;

  align-items: center;
  justify-content: center;

  background-color: transparent;

  z-index: 4;

  pointer-events: none;
}

#topBarRatio {
  aspect-ratio: 16/9;
  max-width: 177.778vh;
  max-height: 56.25vw;

  width: 100%;

  z-index: 4;

  justify-content: center;

  overflow: hidden;

  pointer-events: none;
}


#defaultTopBarHolder {
  position: fixed;
  
  aspect-ratio: 16/9;
  max-width: 177.778vh;
  
  width: 100%;
  
  z-index: 4;
  
  overflow: hidden;
  
  pointer-events: none;

  /* background-color: green; */
}

#selectTopBarHolder {
  display: flex;
  position: relative;

  width: 64.475%;
  height: 3.6574%;

  z-index: 4;

  top: -3%;
  
  left: 50%;
  transform: translate(-50%);
  -moz-transform: translate(-50%);

  pointer-events: none;

  container-type: size;
}

#vertSelectTopBarHolder {
  display: flex;
  position: relative;

  width: 100%;
  height: 3.6574%;

  z-index: 4;
  
  left: 50%;
  transform: translate(-50%);
  -moz-transform: translate(-50%);

  pointer-events: none;

  container-type: size;
}

#topBarImg {
  position: absolute;

  width: 55.8854167%;
  height: 0.740740%;

  top: -0.1%;
  left: 50%;
  transform: translate(-50%);

  z-index: 4;

  justify-content: flex-start;
}

#selectionTopBarImg {
  position: absolute;

  width: 100%;
  height: 100%;

  left: 50%;
  transform: translate(-50%);

  z-index: 4;
}

#vertSelectionTopBar {
  position: relative;

  top: -2%;
  left: -2%;

  width: 18%;
  height:110%;

  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size:contain;
  background-repeat: no-repeat;
  /* background-color: black; */
  /* container-type: size; */
}

#vertSelectionTopBar span {
  position:absolute;

  color: black;

  font-size: 37cqh;
  font-family: MyriadPro-Bold;

  text-transform: uppercase;
  word-spacing: 2cqh;
  /* letter-spacing: 0.1px; */

  white-space: nowrap;

  height: 48%;

  left: 48%;
  top: 40%;
  transform: translate(-50%, -50%);
}

#topLeftCornerBarImg {
  position: absolute;

  width: 9.071%;
  height: 6.15%;

  left: 0%;
  transform: scaleX(-1);

  z-index: 4;

  justify-content: flex-start;
}

#topRightCornerBarImg {
  position: absolute;

  display: flex;
  flex-direction: column;

  width: 9.071%;
  height: 6.15%;

  right: 0%;
  
  /* background-image: url("../../public/Images/Misc/TopCornerBar.png");
  background-size: 100% 100%;
  color: transparent; */
  
  z-index: 4;

  pointer-events: all;
  container-type: size;

  justify-content: flex-start;
}

#loginTypeToggleButton {
  height: 50%;

  white-space: nowrap;

  background-color: rgba(0,0,0,0);
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___}); 
  background-size:100% 100%;
  background-repeat: no-repeat;

  border-width: 0px;
  margin: -1px;
  padding: -5px;

  border-color: rgba(0,0,0,0);
  
  font: 30cqh 'MyriadPro-Regular';
}

#loginTypeToggleButton:hover {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___}); 

  span {
    color: black;
  }
}

#loginTypeToggleButton span {
  position: relative;
  bottom: 10%;

  white-space: nowrap;
  opacity: 1;
  color: white;

  pointer-events: none;
}

#currentLoginTypeSpan {
  pointer-events: none;

  height: 50%;

  padding-top: 3%;

  font: 30cqh 'MyriadPro-Regular';

  white-space: nowrap;

  align-self: center;
}

.hideWhileCollapsed {
  color: transparent;
}

.exposeWhileNotCollapsed {
  color: white;
}

.topLeftShow {
  top: -3.2%;
}

.topLeftClosed {
  top: -5.4%;
}

#versionSpan {
  position: absolute;

  left: 3vw;
  top: 0cqh;
  color:white;

  font-size: 1.1vw;

  z-index: 5;
}

.versionHide {
  opacity: 0.01;
}

.versionShow {
  opacity: 1;
}

.topRightHover {
  top: -3.2%;

  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  background-size: 100% 100%;
  color: transparent;
}

.topRightClick {
  top: 0%;
}

.topRightSelection {
  top: -3.2%;

  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  background-size: 100% 100%;
  color: transparent;
}

.topRightClose {
  top: -5.4%;

  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  background-size: 100% 100%;
  color: transparent;
}

/* Text */
#topBarText {
  position: absolute;

  padding: 0px;
  margin-top: 0px;
  
  left: 50%;
  bottom: 100%;
  transform: translate(-50%, 100%);

  z-index: 4;

  font: 79cqh Diesel;
  text-transform: uppercase;
  color: white;
  text-wrap: nowrap;
}

.introTopBar {
  animation: slideIntoView 0.2s ease 1.5s 1 normal forwards running;
}

.outroTopBar {
  animation: slideOutaView 0.2s ease forwards;
}

.introTopBar_Series {
  top: -10%;
  animation: slideIntoView_SeriesPackage 0.2s ease 1.5s 1 normal forwards running;
}

.outroTopBar_Series {
  top: 0%;
  animation: slideOutaView_SeriesPackage 0.2s ease 0s 1 normal forwards running;
}

.introTopBar_Package {
  top: -10%;
  animation: slideIntoView_SeriesPackage 0.2s ease 0.6s 1 normal forwards running;
}

.outroTopBar_Package {
  top: 0%;
  animation: slideOutaView_SeriesPackage 0.2s ease 0s 1 normal forwards running;
}

@media (min-width: 177.778vh) {
  #topBarRoot_Intro {
    justify-content: start;
  }

  #defaultTopBarHolder {
    max-width: none;
    max-height: 100vh;
  }
}

@keyframes slideIntoView {
  from {top: -3%;}
  to {top: 0%;}
}

@keyframes slideOutaView {
  from {top: 0%;}
  to {top: -3%;}
}

@keyframes slideIntoView_SeriesPackage {
  from {top: -10%;}
  to {top: 0%;}
}

@keyframes slideOutaView_SeriesPackage {
  from {top: 0%;}
  to {top: -10%;}
}`, "",{"version":3,"sources":["webpack://./src/components/TopBar.css"],"names":[],"mappings":"AAAA;EACE,aAAa;;EAEb,kBAAkB;;EAElB,WAAW;EACX,YAAY;;EAEZ,mBAAmB;EACnB,uBAAuB;;EAEvB,6BAA6B;;EAE7B,YAAY;;EAEZ,oBAAoB;AACtB;;AAEA;EACE,aAAa;;EAEb,kBAAkB;;EAElB,WAAW;EACX,YAAY;;EAEZ,mBAAmB;EACnB,uBAAuB;;EAEvB,6BAA6B;;EAE7B,UAAU;;EAEV,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;;EAEnB,WAAW;;EAEX,UAAU;;EAEV,uBAAuB;;EAEvB,gBAAgB;;EAEhB,oBAAoB;AACtB;;;AAGA;EACE,eAAe;;EAEf,kBAAkB;EAClB,oBAAoB;;EAEpB,WAAW;;EAEX,UAAU;;EAEV,gBAAgB;;EAEhB,oBAAoB;;EAEpB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,kBAAkB;;EAElB,cAAc;EACd,eAAe;;EAEf,UAAU;;EAEV,QAAQ;;EAER,SAAS;EACT,0BAA0B;EAC1B,+BAA+B;;EAE/B,oBAAoB;;EAEpB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,kBAAkB;;EAElB,WAAW;EACX,eAAe;;EAEf,UAAU;;EAEV,SAAS;EACT,0BAA0B;EAC1B,+BAA+B;;EAE/B,oBAAoB;;EAEpB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;;EAElB,kBAAkB;EAClB,iBAAiB;;EAEjB,UAAU;EACV,SAAS;EACT,0BAA0B;;EAE1B,UAAU;;EAEV,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;;EAElB,WAAW;EACX,YAAY;;EAEZ,SAAS;EACT,0BAA0B;;EAE1B,UAAU;AACZ;;AAEA;EACE,kBAAkB;;EAElB,QAAQ;EACR,SAAS;;EAET,UAAU;EACV,WAAW;;EAEX,yDAA+E;EAC/E,uBAAuB;EACvB,4BAA4B;EAC5B,6BAA6B;EAC7B,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;;EAEjB,YAAY;;EAEZ,gBAAgB;EAChB,2BAA2B;;EAE3B,yBAAyB;EACzB,kBAAkB;EAClB,2BAA2B;;EAE3B,mBAAmB;;EAEnB,WAAW;;EAEX,SAAS;EACT,QAAQ;EACR,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;;EAElB,aAAa;EACb,aAAa;;EAEb,QAAQ;EACR,qBAAqB;;EAErB,UAAU;;EAEV,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;;EAElB,aAAa;EACb,sBAAsB;;EAEtB,aAAa;EACb,aAAa;;EAEb,SAAS;;EAET;;uBAEqB;;EAErB,UAAU;;EAEV,mBAAmB;EACnB,oBAAoB;;EAEpB,2BAA2B;AAC7B;;AAEA;EACE,WAAW;;EAEX,mBAAmB;;EAEnB,+BAA+B;EAC/B,yDAAmE;EACnE,yBAAyB;EACzB,4BAA4B;;EAE5B,iBAAiB;EACjB,YAAY;EACZ,aAAa;;EAEb,2BAA2B;;EAE3B,+BAA+B;AACjC;;AAEA;EACE,yDAAyE;;EAEzE;IACE,YAAY;EACd;AACF;;AAEA;EACE,kBAAkB;EAClB,WAAW;;EAEX,mBAAmB;EACnB,UAAU;EACV,YAAY;;EAEZ,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;;EAEpB,WAAW;;EAEX,eAAe;;EAEf,+BAA+B;;EAE/B,mBAAmB;;EAEnB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;;EAElB,SAAS;EACT,SAAS;EACT,WAAW;;EAEX,gBAAgB;;EAEhB,UAAU;AACZ;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;;EAEV,yDAAkE;EAClE,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,UAAU;;EAEV,yDAAkE;EAClE,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,UAAU;;EAEV,yDAAkE;EAClE,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA,SAAS;AACT;EACE,kBAAkB;;EAElB,YAAY;EACZ,eAAe;;EAEf,SAAS;EACT,YAAY;EACZ,gCAAgC;;EAEhC,UAAU;;EAEV,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,iEAAiE;AACnE;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,SAAS;EACT,+EAA+E;AACjF;;AAEA;EACE,OAAO;EACP,6EAA6E;AAC/E;;AAEA;EACE,SAAS;EACT,+EAA+E;AACjF;;AAEA;EACE,OAAO;EACP,6EAA6E;AAC/E;;AAEA;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;AACF;;AAEA;EACE,MAAM,QAAQ,CAAC;EACf,IAAI,OAAO,CAAC;AACd;;AAEA;EACE,MAAM,OAAO,CAAC;EACd,IAAI,QAAQ,CAAC;AACf;;AAEA;EACE,MAAM,SAAS,CAAC;EAChB,IAAI,OAAO,CAAC;AACd;;AAEA;EACE,MAAM,OAAO,CAAC;EACd,IAAI,SAAS,CAAC;AAChB","sourcesContent":["#topBarRoot {\r\n  display: flex;\r\n\r\n  position: absolute;\r\n\r\n  width: 100%;\r\n  height: 100%;\r\n\r\n  align-items: center;\r\n  justify-content: center;\r\n\r\n  background-color: transparent;\r\n\r\n  z-index: 100;\r\n\r\n  pointer-events: none;\r\n}\r\n\r\n#topBarRoot_Intro {\r\n  display: flex;\r\n\r\n  position: absolute;\r\n\r\n  width: 100%;\r\n  height: 100%;\r\n\r\n  align-items: center;\r\n  justify-content: center;\r\n\r\n  background-color: transparent;\r\n\r\n  z-index: 4;\r\n\r\n  pointer-events: none;\r\n}\r\n\r\n#topBarRatio {\r\n  aspect-ratio: 16/9;\r\n  max-width: 177.778vh;\r\n  max-height: 56.25vw;\r\n\r\n  width: 100%;\r\n\r\n  z-index: 4;\r\n\r\n  justify-content: center;\r\n\r\n  overflow: hidden;\r\n\r\n  pointer-events: none;\r\n}\r\n\r\n\r\n#defaultTopBarHolder {\r\n  position: fixed;\r\n  \r\n  aspect-ratio: 16/9;\r\n  max-width: 177.778vh;\r\n  \r\n  width: 100%;\r\n  \r\n  z-index: 4;\r\n  \r\n  overflow: hidden;\r\n  \r\n  pointer-events: none;\r\n\r\n  /* background-color: green; */\r\n}\r\n\r\n#selectTopBarHolder {\r\n  display: flex;\r\n  position: relative;\r\n\r\n  width: 64.475%;\r\n  height: 3.6574%;\r\n\r\n  z-index: 4;\r\n\r\n  top: -3%;\r\n  \r\n  left: 50%;\r\n  transform: translate(-50%);\r\n  -moz-transform: translate(-50%);\r\n\r\n  pointer-events: none;\r\n\r\n  container-type: size;\r\n}\r\n\r\n#vertSelectTopBarHolder {\r\n  display: flex;\r\n  position: relative;\r\n\r\n  width: 100%;\r\n  height: 3.6574%;\r\n\r\n  z-index: 4;\r\n  \r\n  left: 50%;\r\n  transform: translate(-50%);\r\n  -moz-transform: translate(-50%);\r\n\r\n  pointer-events: none;\r\n\r\n  container-type: size;\r\n}\r\n\r\n#topBarImg {\r\n  position: absolute;\r\n\r\n  width: 55.8854167%;\r\n  height: 0.740740%;\r\n\r\n  top: -0.1%;\r\n  left: 50%;\r\n  transform: translate(-50%);\r\n\r\n  z-index: 4;\r\n\r\n  justify-content: flex-start;\r\n}\r\n\r\n#selectionTopBarImg {\r\n  position: absolute;\r\n\r\n  width: 100%;\r\n  height: 100%;\r\n\r\n  left: 50%;\r\n  transform: translate(-50%);\r\n\r\n  z-index: 4;\r\n}\r\n\r\n#vertSelectionTopBar {\r\n  position: relative;\r\n\r\n  top: -2%;\r\n  left: -2%;\r\n\r\n  width: 18%;\r\n  height:110%;\r\n\r\n  background-image: url(\"../../public/Images/Misc/SeriesPackageInstructions.png\");\r\n  background-size:contain;\r\n  background-repeat: no-repeat;\r\n  /* background-color: black; */\r\n  /* container-type: size; */\r\n}\r\n\r\n#vertSelectionTopBar span {\r\n  position:absolute;\r\n\r\n  color: black;\r\n\r\n  font-size: 37cqh;\r\n  font-family: MyriadPro-Bold;\r\n\r\n  text-transform: uppercase;\r\n  word-spacing: 2cqh;\r\n  /* letter-spacing: 0.1px; */\r\n\r\n  white-space: nowrap;\r\n\r\n  height: 48%;\r\n\r\n  left: 48%;\r\n  top: 40%;\r\n  transform: translate(-50%, -50%);\r\n}\r\n\r\n#topLeftCornerBarImg {\r\n  position: absolute;\r\n\r\n  width: 9.071%;\r\n  height: 6.15%;\r\n\r\n  left: 0%;\r\n  transform: scaleX(-1);\r\n\r\n  z-index: 4;\r\n\r\n  justify-content: flex-start;\r\n}\r\n\r\n#topRightCornerBarImg {\r\n  position: absolute;\r\n\r\n  display: flex;\r\n  flex-direction: column;\r\n\r\n  width: 9.071%;\r\n  height: 6.15%;\r\n\r\n  right: 0%;\r\n  \r\n  /* background-image: url(\"../../public/Images/Misc/TopCornerBar.png\");\r\n  background-size: 100% 100%;\r\n  color: transparent; */\r\n  \r\n  z-index: 4;\r\n\r\n  pointer-events: all;\r\n  container-type: size;\r\n\r\n  justify-content: flex-start;\r\n}\r\n\r\n#loginTypeToggleButton {\r\n  height: 50%;\r\n\r\n  white-space: nowrap;\r\n\r\n  background-color: rgba(0,0,0,0);\r\n  background-image: url(../../public/Images/Misc/TopCornerButton.png); \r\n  background-size:100% 100%;\r\n  background-repeat: no-repeat;\r\n\r\n  border-width: 0px;\r\n  margin: -1px;\r\n  padding: -5px;\r\n\r\n  border-color: rgba(0,0,0,0);\r\n  \r\n  font: 30cqh 'MyriadPro-Regular';\r\n}\r\n\r\n#loginTypeToggleButton:hover {\r\n  background-image: url(../../public/Images/Misc/TopCornerButton_Hover.png); \r\n\r\n  span {\r\n    color: black;\r\n  }\r\n}\r\n\r\n#loginTypeToggleButton span {\r\n  position: relative;\r\n  bottom: 10%;\r\n\r\n  white-space: nowrap;\r\n  opacity: 1;\r\n  color: white;\r\n\r\n  pointer-events: none;\r\n}\r\n\r\n#currentLoginTypeSpan {\r\n  pointer-events: none;\r\n\r\n  height: 50%;\r\n\r\n  padding-top: 3%;\r\n\r\n  font: 30cqh 'MyriadPro-Regular';\r\n\r\n  white-space: nowrap;\r\n\r\n  align-self: center;\r\n}\r\n\r\n.hideWhileCollapsed {\r\n  color: transparent;\r\n}\r\n\r\n.exposeWhileNotCollapsed {\r\n  color: white;\r\n}\r\n\r\n.topLeftShow {\r\n  top: -3.2%;\r\n}\r\n\r\n.topLeftClosed {\r\n  top: -5.4%;\r\n}\r\n\r\n#versionSpan {\r\n  position: absolute;\r\n\r\n  left: 3vw;\r\n  top: 0cqh;\r\n  color:white;\r\n\r\n  font-size: 1.1vw;\r\n\r\n  z-index: 5;\r\n}\r\n\r\n.versionHide {\r\n  opacity: 0.01;\r\n}\r\n\r\n.versionShow {\r\n  opacity: 1;\r\n}\r\n\r\n.topRightHover {\r\n  top: -3.2%;\r\n\r\n  background-image: url(\"../../public/Images/Misc/TopCornerBar.png\");\r\n  background-size: 100% 100%;\r\n  color: transparent;\r\n}\r\n\r\n.topRightClick {\r\n  top: 0%;\r\n}\r\n\r\n.topRightSelection {\r\n  top: -3.2%;\r\n\r\n  background-image: url(\"../../public/Images/Misc/TopCornerBar.png\");\r\n  background-size: 100% 100%;\r\n  color: transparent;\r\n}\r\n\r\n.topRightClose {\r\n  top: -5.4%;\r\n\r\n  background-image: url(\"../../public/Images/Misc/TopCornerBar.png\");\r\n  background-size: 100% 100%;\r\n  color: transparent;\r\n}\r\n\r\n/* Text */\r\n#topBarText {\r\n  position: absolute;\r\n\r\n  padding: 0px;\r\n  margin-top: 0px;\r\n  \r\n  left: 50%;\r\n  bottom: 100%;\r\n  transform: translate(-50%, 100%);\r\n\r\n  z-index: 4;\r\n\r\n  font: 79cqh Diesel;\r\n  text-transform: uppercase;\r\n  color: white;\r\n  text-wrap: nowrap;\r\n}\r\n\r\n.introTopBar {\r\n  animation: slideIntoView 0.2s ease 1.5s 1 normal forwards running;\r\n}\r\n\r\n.outroTopBar {\r\n  animation: slideOutaView 0.2s ease forwards;\r\n}\r\n\r\n.introTopBar_Series {\r\n  top: -10%;\r\n  animation: slideIntoView_SeriesPackage 0.2s ease 1.5s 1 normal forwards running;\r\n}\r\n\r\n.outroTopBar_Series {\r\n  top: 0%;\r\n  animation: slideOutaView_SeriesPackage 0.2s ease 0s 1 normal forwards running;\r\n}\r\n\r\n.introTopBar_Package {\r\n  top: -10%;\r\n  animation: slideIntoView_SeriesPackage 0.2s ease 0.6s 1 normal forwards running;\r\n}\r\n\r\n.outroTopBar_Package {\r\n  top: 0%;\r\n  animation: slideOutaView_SeriesPackage 0.2s ease 0s 1 normal forwards running;\r\n}\r\n\r\n@media (min-width: 177.778vh) {\r\n  #topBarRoot_Intro {\r\n    justify-content: start;\r\n  }\r\n\r\n  #defaultTopBarHolder {\r\n    max-width: none;\r\n    max-height: 100vh;\r\n  }\r\n}\r\n\r\n@keyframes slideIntoView {\r\n  from {top: -3%;}\r\n  to {top: 0%;}\r\n}\r\n\r\n@keyframes slideOutaView {\r\n  from {top: 0%;}\r\n  to {top: -3%;}\r\n}\r\n\r\n@keyframes slideIntoView_SeriesPackage {\r\n  from {top: -10%;}\r\n  to {top: 0%;}\r\n}\r\n\r\n@keyframes slideOutaView_SeriesPackage {\r\n  from {top: 0%;}\r\n  to {top: -10%;}\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
